const SUPERTHEM_ROOT = 'superthem.com';

/** 当前站点是否为 superthem.com 或其子域名（含 www.superthem.com）。 */
export const isSuperthemHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  return host === SUPERTHEM_ROOT || host.endsWith(`.${SUPERTHEM_ROOT}`);
};
